import styled from "styled-components";
import Card from "../../components/layout/card";
import { ParagraphMedium } from "baseui/typography";

export const StyledCard = styled(Card)`
  max-width: 540px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.sizing.scale1000} ${({ theme }) => theme.sizing.scale1200};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${({ theme }) => theme.sizing.scale1000};
  margin-bottom: ${({ theme }) => theme.sizing.scale900};
  display: flex;
  flex-direction: column;

  .styled-inputs label {
    font-family: ${({ theme }) => theme.typography.LabelMedium.fontFamily};
    font-weight: ${({ theme }) => theme.typography.LabelMedium.fontWeight};
    font-size: ${({ theme }) => theme.typography.LabelMedium.fontSize};
    line-height: ${({ theme }) => theme.typography.LabelMedium.lineHeight};
    text-transform: none;
  }
`;

export const StyledHeading = styled.h1`
  font-family: ${({ theme }) => theme.typography.HeadingSmall.fontFamily};
  font-weight: ${({ theme }) => theme.typography.HeadingSmall.fontWeight};
  font-size: ${({ theme }) => theme.typography.HeadingSmall.fontSize};
  line-height: ${({ theme }) => theme.typography.HeadingSmall.lineHeight};
  margin-top: ${({ theme }) => theme.sizing.scale1000};
  margin-bottom: ${({ theme }) => theme.sizing.scale300};
`;

export const StyledParagraphMedium = styled(ParagraphMedium)`
  margin-top: ${({ theme }) => theme.sizing.scale300};
  margin-bottom: ${({ theme }) => theme.sizing.scale800};
  color: ${({ theme }) => theme.colors.contentTertiary};

  .styled-highlighted-paragraph {
    font-weight: 700;
  }
`;
